import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateLanguageService } from '../../../abraj-shared/src/lib/services/translate-language.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
   public readonly languageService = inject(TranslateLanguageService);

}
